"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldHeading = exports.getLabelId = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var RequiredLabel_1 = require("../RequiredLabel");
var StyledHeading = styled_1.default.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  line-height: 1.7;\n  font-weight: bold;\n  font-size: 16px;\n  display: block;\n  word-break: break-all;\n"], ["\n  line-height: 1.7;\n  font-weight: bold;\n  font-size: 16px;\n  display: block;\n  word-break: break-all;\n"])));
var StyledHeadingText = styled_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var color = _a.color;
    return color;
});
var StyledBadge = styled_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: inline-block;\n  vertical-align: text-bottom;\n  margin-left: 8px;\n"], ["\n  display: inline-block;\n  vertical-align: text-bottom;\n  margin-left: 8px;\n"])));
var PRE_LABEL_ID = 'label-';
var getLabelId = function (propertyId) {
    if (propertyId === void 0) { propertyId = ''; }
    return "".concat(PRE_LABEL_ID).concat(propertyId);
};
exports.getLabelId = getLabelId;
exports.FieldHeading = react_1.default.memo(function (_a) {
    var name = _a.name, required = _a.required, color = _a.color, displayRequiredLabel = _a.displayRequiredLabel, className = _a.className, propertyId = _a.propertyId, notUseLabelTag = _a.notUseLabelTag;
    var headingProps = __assign(__assign({}, (className && { className: className })), (propertyId && {
        htmlFor: (!notUseLabelTag && propertyId) || undefined,
        id: (0, exports.getLabelId)(propertyId),
    }));
    return (react_1.default.createElement(StyledHeading, __assign({ as: (notUseLabelTag && 'div') || undefined }, headingProps),
        react_1.default.createElement(StyledHeadingText, { color: color, dangerouslySetInnerHTML: {
                __html: name,
            } }),
        displayRequiredLabel && (react_1.default.createElement(StyledBadge, null,
            react_1.default.createElement(RequiredLabel_1.RequiredLabel, { required: required })))));
});
var templateObject_1, templateObject_2, templateObject_3;
